export var CURRENCY = 'USD';
export var LOCALE = 'en-US';
export var PLACEHOLDER = '--';
export var VW_DATE_FORMAT = 'MM/dd/yyyy';

//# sourceMappingURL=strings.js.map